/* eslint-disable react/prop-types */
import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import NumberFormat from '../../utils/NumberFormat';
// eslint-disable-next-line react/prop-types
function CustomTooltip({ payload, label, active }) {
  // eslint-disable-next-line react/prop-types
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`Mês: ${label}`}</p>
        <p className="desc">{`Receitas: ${NumberFormat(payload[0].value)}`}</p>
        <p className="desc">{`Total Despesas: ${NumberFormat(
          payload[1].value
        )}`}</p>
      </div>
    );
  }

  return null;
}

function mergeData(dados1, dados2) {
  const monthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ];
  return dados1.map((item1) => {
    const item2 = dados2.find((item) => item.mes === item1.mes);

    // Assegure-se de que os valores sejam números, caso possam ser indefinidos
    const Receitas = item1.Receitas || 0;
    const Despesas = item1.Despesas || 0;
    const Valor = item2 ? item2.Valor : 0;

    return {
      mes: monthNames[item1.mes - 1] || item1.mes,
      Receitas,
      'Total Despesas': Despesas + Valor,
    };
  });
}

function Example({ dados1, dados2 }) {
  const data = mergeData(dados1, dados2);

  return (
    <LineChart
      width={400}
      height={300}
      data={data}
      margin={{
        top: 5,
        right: 5,
        left: 5,
        bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="mes" />
      <YAxis />
      <Tooltip content={<CustomTooltip />} />
      <Legend />
      <Line
        type="monotone"
        dataKey="Receitas"
        stroke="#8884d8"
        activeDot={{ r: 8 }}
      />
      <Line type="monotone" dataKey="Total Despesas" stroke="#82ca9d" />
    </LineChart>
  );
}

export default Example;
